/** Test kart dropdown / banner — yalnızca aktif ödeme entegrasyonu test_mode=true iken */
export function showPaymentTestCardUi(testMode: boolean | undefined): boolean {
  return Boolean(testMode);
}
